import { components } from "@certn/api/generated-schemas/client-portal";
import { Card } from "@certn/cascadia-react";

import { CommentSection } from "../../../components/comment-section/CommentSection";

interface Props {
  comments: readonly components["schemas"]["CaseComment"][];
  mutate: any;
}
export function CommentSectionTab(props: Props) {
  const { comments, mutate } = props;
  return (
    <Card testID="comment-section" type="large" responsive>
      <CommentSection comments={comments} mutate={mutate} />
    </Card>
  );
}
